import { render } from "./ClientSpaceAgreement.vue?vue&type=template&id=eb4bf50a"
import script from "./ClientSpaceAgreement.vue?vue&type=script&lang=js"
export * from "./ClientSpaceAgreement.vue?vue&type=script&lang=js"

import "./ClientSpaceAgreement.vue?vue&type=style&index=0&id=eb4bf50a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__